<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Documents</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
  </div>
</template>
<script>
  // Components
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

  export default {
    components: {
      RouteBreadCrumb
    },
    data() {
      return {
        
      };
    },
    methods: {

    },
    mounted() {
    }
  }
</script>